import * as React from 'react';
import * as styles from './Label.css';

export interface ILabelProps {
  labelText: string;
}

export function Label(props: ILabelProps) {
  const { labelText } = props;

  return (
    <div className={styles['wrapper']}>
      <span className={styles['label']}>{labelText}</span>
    </div>
  );
}
